import Materiau from './Materiau'

const Block = ({blockTitle, blockContent, hasInput, inputDescription, inputLabel}) => {

    return(
        <>
            <div className="form-container">
  <div className="form-head">
    {/* <p className="text-center">Je sélectionne ma couverture de toiture</p> */}
    <p className="text-center">{blockTitle}</p>
  </div>
  <div className="be-form p-3 p-md-5">
    <form action="">
      <div className="text-center" style={{}}>
        <div className="row select-elements">
            {blockContent?.map((materiau, index) => (
                <Materiau 
                    key={index}
                    imageUrl={materiau.imageUrl}
                    title={materiau.title}
                    description={materiau.description}
                />
            ))}
        </div>
      </div>
      {hasInput && (
            <div className="mt-4">
              <div className="d-flex flex-column">
                <label htmlFor="" className="label-be">
                  {inputLabel || 'Votre charpente sera apparente ou non apparente :'}
                </label>
                <div className="input-wrapper">
                  <input type="text" />
                  <span className="unit">mm</span>
                </div>
              </div>
              <div className="to-consider">
                <p>{inputDescription || 'Qualité visuelle accrue pour les bois apparents'}</p>
              </div>
            </div>
          )}
      {/* {hasInput && 
        <div className="mt-4">
            <div className="d-flex flex-column" style={{}}>
                <label htmlFor="" className="label-be">
                    Votre charpente sera apparente ou non apparente :
                </label>
                <div className="input-wrapper">
                    <input type="text" />
                    <span className="unit">mm</span>
                </div>
            </div>
            <div className="to-consider">
                <p>Qualité visuelle accrue pour les bois apparents</p>
            </div>
        </div>
      } */}
      <div className="other-choice">
        <div className="row">
          <div className="col-12 col-md-3">
            <div className="other-choice-box">
              <p className="text-center">AUTRE CHOIX</p>
            </div>
          </div>
          <div className="d-flex flex-column" style={{ width: 400 }}>
            <label htmlFor="" className="label-be">
              Quelle Isolation
            </label>
            <input type="text" />
            <label htmlFor="" className="label-be mt-auto">
              Indiquez le poids du produit
            </label>
            {/* <input type="text"> */}
            <div className="input-wrapper">
              <input type="text" />
              <span className="unit">Kg/m²</span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

        </>
    )

}

export default Block;